/**
 *
 * EnableCustomerCarePopup
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 27-Jan-2023
 */

import React from 'react';
import PropTypes from 'prop-types';
import PortalModal from 'Components/PortalModal/PortalModal';
import formattedMessages from '../../modules/languageModule';
import { useNavigate } from 'react-router-dom';
import style from './EnableCustomerCarePopup.scss';

const EnableCustomerCarePopup = (props) => {
	const navigate = useNavigate();

	return (
		<PortalModal
			className={style.container}
			title={formattedMessages.warning}
			subtitle={formattedMessages.subtitleEnable}
			actions={{ handleClose: () => {} }}
			buttons={[
				{
					variant: 'outlined',
					onClick: props.actions.closeModal,
					contentText: formattedMessages.abortLabelButton,
				},
				{
					variant: 'contained',
					onClick: () => {
						props.actions.enableCustomerCare(props.payload);
						setTimeout(() => {
							navigate('/customer-care');
						}, 5000);
					},
					contentText: formattedMessages.confirmLabelButton,
					isLoading: props.isLoading,
				},
			]}
		/>
	);
};

EnableCustomerCarePopup.propTypes = {
	actions: PropTypes.objectOf(PropTypes.func),
	isLoading: PropTypes.bool,
	status: PropTypes.string,
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

EnableCustomerCarePopup.defaultProps = {
	isLoading: false,
	status: '',
	payload: {},
};

export default EnableCustomerCarePopup;
